import { IRegisteredComponent } from '../RenderingAnchor/rendering.provider.model';

const pluginComponents: IRegisteredComponent[] = [];

export const registerPluginComponents = (components: IRegisteredComponent[]): void => {
  components.forEach((component) => {
    const isAlreadyRegistered = pluginComponents.some(
      (registered) => registered.anchor === component.anchor && registered.component === component.component,
    );

    if (!isAlreadyRegistered) {
      pluginComponents.push(component);
    }
  });
};

export const getPluginComponents = (): IRegisteredComponent[] => pluginComponents;

export const clearPluginComponents = (): void => {
  pluginComponents.length = 0;
};
